import request from "../request";
import base from "@/api/base";

export default {
  // 移除直接创建的 request 实例，改为动态生成
  getRequest() {
    // 每次请求前都获取最新的 baseUrl
    return new request(`${base.getUsrBaseUrl()}/web/user`);
  },

  login(account, password) {
    return this.getRequest().post("/login", { account, password });
  },

  getVersion(params = {}) {
    return this.getRequest().get("/version", params);
  },
};
